export default __webpack_public_path__ + "static/media/September2019.081c518e.png";